import moment from 'moment';
const UPDATED_AT = '2019/04';
export default {
  updatedAt: moment(UPDATED_AT).toDate(),
};
